<!--テストデータ選択ダイアログ-->
<div style="margin: 20px;">
    <is-igx-hub
        [mappingData]="selectTestDataHubSettings"
        [leftWbsData]="staticSelectTestData"
        [actions]="selectTestDataHubActions"
        #selectDataHub>    
    </is-igx-hub>
    <button igxButton="flat" (click)="openTestDataHub()">テストデータ選択 HUB Open</button>
</div>
<!-- 固定データ確認 -->
<is-igx-mapping *ngIf="!loading" 
    [mappingData]="mappingData"
    [leftWbsData]="StaticLeftWbsData"
    [rightWbsData]="StaticRightWbsData"
    [mappingDataHub]="mappingDataHub"    
    >
</is-igx-mapping>

<pre>
    <textarea [(ngModel)]="mappingDataString" style="width: 90%; height: 300px"></textarea>
    <button (click)="reflectMappingData()">反映</button> 
 </pre>